"use client"
import {
  Collapse, Button, Flex, Card,
  message as messageToast
} from 'antd';
import type { CollapseProps } from 'antd';
import Link from 'next/link';
import Image from 'next/image';
import { RateCustom } from '@/app/components/common/RateCustom/index';
import { Numeric } from "@/app/components/common/Numeric";
import { ProductProps, SKUProps } from "@/types/index";
import { useRouter } from "next/navigation";
import { addShopingCart, queryShopingCartNum } from '@/service/carts';
import userInfoStore from "@/store/userInfoStore";
import { useEffect, useState, useMemo } from "react";
import useSWR from "swr";
import shopCartStore from '@/store/shopCartStore';
import { addGtag, changeUrl, handleImgUrl } from "@/utils/tools";
import { BravveInputNumber } from '@/app/components/common/BravveInputNumber';
import currency from 'currency.js';
import Logistics from "@/app/assets/product/logistics.svg";
import { getShippingFeeConf } from "@/service/common/index";
import { PrivacyPolicyPagesEnum } from '@/utils/const';
import { returnPricacyPolicyUrl } from '@/utils/tools';
import { Event_Name, Login_Click } from '@/service/user/enum';
import { ViewportTracker } from '@/app/components/viewportTracker';

import './index.css';
import CustomLoadingButton from '../common/SelfButton';
import { BravveSmartButton } from '../common/BravveSmartButton';
import { isMobile } from 'react-device-detect';
// import { Login } from '../user/login';

export type ProductPriceProps = {
  productData: ProductProps
  currentSku: SKUProps
  type?: string
};
export const ProductPrice: React.FC<ProductPriceProps> = ({
  productData,
  currentSku,
  type,
  ...props
}) => {
  const { userInfo } = userInfoStore();
  const [amount, setAmount] = useState(1);
  const [orderOverFreShippingAmount, setOrderOverFreShippingAmount] = useState(0);
  const { setShopCart, shopCartInfo } = shopCartStore();
  const [total, setTotal] = useState("");

  const router = useRouter();

  currentSku.discount = parseFloat(((currentSku?.originPrice - currentSku?.salePrice) / currentSku?.originPrice * 100).toFixed(0))

  const isUnavailableOrStock = useMemo(() => {
    return currentSku?.stock === 0 || currentSku?.activeFlag === false || productData.status !== "UP"
  }, [currentSku, productData])


  // console.log("currentSku : ", currentSku)

  // const colorKeyValue = {}
  const saleAttributeList = productData.skuUrl.map((item, idx) => {
    // colorKeyValue[item.saleAttribute.color] = item.colorValue
    return { ...item.saleAttribute, img: productData.shopProductItemDetailVos[idx].images.whiteBackPic[0] }
  }).filter(item => item)

  // console.log("saleAttributeList : ", saleAttributeList)

  type Item = { color?: string; size?: string };
  type Merged = { [key: string]: string[] };

  let merged: Merged = saleAttributeList.reduce((acc, obj) => {
    Object.keys(obj).forEach((key) => {
      // 如果该属性没有数组，初始化一个 Set 来去重
      if (!acc[key]) {
        // @ts-ignore
        acc[key] = new Set();
      }
      // @ts-ignore
      // 将当前对象的值添加到 Set 中
      acc[key].add(obj[key as keyof Item]);
    });
    return acc;
  }, {} as Merged);

  // 将 Set 转换为数组
  merged = Object.keys(merged).reduce((acc, key) => {
    // @ts-ignore
    acc[key] = Array.from(merged[key] as Set<number>);
    return acc;
  }, {} as Merged);

  // console.log("merged : ", merged)

  // let keyExceptionColorAndImg = ''
  const keysExceptionColorAndImgArr: string[] = []
  const saleAttributeExceptionColorAndImg: {[key: string]: string[]} = {}
  Object.keys(merged).forEach(key => {
    if(key === "color" || key === "img") {

    } else {
      // keyExceptionColorAndImg = key
      keysExceptionColorAndImgArr.push(key)
      saleAttributeExceptionColorAndImg[key] = merged[key]
    }
  })

  // console.log("saleAttributeExceptionColorAndImg : ", saleAttributeExceptionColorAndImg)

  const saleAttributeExceptionColorAndImgValueslength = Object.values(saleAttributeExceptionColorAndImg).reduce((count, row) => count * row.length, 1);

  // console.log("saleAttributeExceptionColorAndImgValueslength : ", saleAttributeExceptionColorAndImgValueslength)

  const items: CollapseProps['items'] = merged?.color ? [
    {
      key: '1',
      label: <div className='text-lg flex items-center'>
        <span className="font-medium firstLetterUppercase text-bravve-100">Color: </span>
        <span className="text-bravve-sub-100 ml-6">{currentSku.saleAttribute.color}</span>
      </div>,
      children: <div className='flex gap-12 flex-wrap pb-24'>
        {
          merged?.color?.map((item, index) => <div
            onClick={() => navigatorToNewProduct({
              key: "color",
              value: item
            })}
            className={'w-60 h-60 border-[1.5px] cursor-pointer flex justify-center items-center overflow-hidden ' +
              (item === currentSku.saleAttribute.color ? ' border-bravve-100 ' : ' border-bravve-line-200 ') +
              (isUnavailableOrStock && currentSku.saleAttribute.color === item ? ' opacity-30' : '')
            }
            key={item}
          >
            {/* <Image src={handleImgUrl(process.env.NEXT_PUBLIC_IMAGE_URL + merged.img[index], '200x200')} 
                alt={productData.name} style={{width: '100%', height: '100%'}} width={60} height={60} /> */}
            {
              merged?.color.length === 1 ?
              <Image src={handleImgUrl(process.env.NEXT_PUBLIC_IMAGE_URL + currentSku.images.whiteBackPic[0], '200x200')} 
                alt={productData.name} style={{width: '100%', height: '100%'}} width={60} height={60} />
              :
              <Image src={handleImgUrl(process.env.NEXT_PUBLIC_IMAGE_URL + merged.img[saleAttributeExceptionColorAndImgValueslength ? (index * saleAttributeExceptionColorAndImgValueslength) : index], '200x200')} 
                alt={productData.name} style={{width: '100%', height: '100%'}} width={60} height={60} />
            }
            {
              isUnavailableOrStock && currentSku.saleAttribute.color === item ? 
                <div className='h-1 bg-white w-50 rotate-[135deg] '></div> : null
            }
          </div>
          )
        }
      </div>
    }
  ]
  :
  []

  const gridStyle: React.CSSProperties = {
    width: '50%',
    // height: 60,
    // lineHeight: "60px",
    textAlign: 'center',
    padding: 0,
    margin: 0,
    zIndex: 1,
    // border: 'solid 2px #DEDBD5',
    // boxShadow: 'none',
    overflow: 'hidden',
    borderRadius: 0,
    boxShadow: '2px 0 0 0 #DEDBD5,0 2px 0 0 #DEDBD5, 2px 2px 0 0 #DEDBD5, 2px 0 0 0 #DEDBD5 inset, 0 2px 0 0 #DEDBD5 inset'
  };

  const items1: CollapseProps['items'] = keysExceptionColorAndImgArr.map((key, idx) => {
    return ({
      key: idx + 2 + '',
      label: <div className='text-lg flex items-center'>
        <span className="font-medium firstLetterUppercase text-bravve-100">{key}: </span>
        <span className="text-bravve-sub-100 ml-6">{currentSku.saleAttribute[key]}</span>
      </div>,
      children: <div className='pb-32'>
        <Card bordered={false} style={{boxShadow: 'none'}}>
        {
          merged[key].map((item, index) => 
          <Card.Grid 
            style={{ ...gridStyle, ...(item === currentSku.saleAttribute[key] ?
                {boxShadow: '2px 0 0 0 #402C22,0 2px 0 0 #402C22, 2px 2px 0 0 #402C22, 2px 0 0 0 #402C22 inset, 0 2px 0 0 #402C22 inset', zIndex: 2}
              :
              {boxShadow: '2px 0 0 0 #DEDBD5,0 2px 0 0 #DEDBD5, 2px 2px 0 0 #DEDBD5, 2px 0 0 0 #DEDBD5 inset, 0 2px 0 0 #DEDBD5 inset'})
              }}
            key={key + index} 
            onClick={() => navigatorToNewProduct({
              key: key,
              value: item
            })}
            className={'cursor-pointer font-medium text-lg h-49 leading-[49px] xl:h-60 xl:leading-[60px]'
              // + (item === currentSku.saleAttribute[key] ? ' outline-2 outline-red-50' : '')
              + (isUnavailableOrStock && currentSku.saleAttribute[key] === item ? ' opacity-30 ' : '')}
          >
            {item}
          </Card.Grid>
          )
        }
        </Card>
      </div>
    })
  });

  useEffect(() => {

    const cTotal = currency(currentSku.salePrice).multiply(amount);
    setTotal(cTotal.format({ precision: 2 }))

  }, [amount, currentSku.salePrice])

  const { data } = useSWR(["getShippingFeeConf"], async () => {
    // 获取运费配置
    const { data } = await getShippingFeeConf<{totalAmount: number}>({
      country: "USA"
    })
    return data
  }, { revalidateOnFocus: false })

  useEffect(() => {
    if (data) {
      setOrderOverFreShippingAmount(data?.totalAmount);
    }
  }, [data])
  
  const navigatorToNewProduct = (params: { key: string, value: string }) => {
    goToSkuUrl({
      ...currentSku.saleAttribute,
      [params.key]: params.value
    })
  }

  const goToSkuUrl = (toSaleAttribute: { color: string, [key: string]: string }, isReturn?: boolean) => {
    let skuUrl = '';
    productData.skuUrl.map((sku) => {
      if (JSON.stringify(sku.saleAttribute) === JSON.stringify(toSaleAttribute)) {
        skuUrl = sku.url
        if (isReturn) return
        router.push(changeUrl(sku.url))
      }
    })
    return skuUrl
  }

  /**
   * 添加商品到购物车
   */
  const addToCart = async () => {
    const skuUrl = goToSkuUrl(currentSku.saleAttribute, true) || '';
    // console.log(skuUrl, 'currentSku')
    const { status, message } = await addShopingCart({
      productId: productData.spuId,
      itemId: currentSku.id,
      count: amount,
      price: currentSku.salePrice,
      cur: currentSku.currency,
      skuUrl: skuUrl || ''
    })
    console.log("addToCart : ", status)

    if (status && status == 200) {
      // 刷新购物车数量
      const cartData = await queryShopingCartNum();
      if (cartData?.status === 200) {
        let count = cartData?.data?.count || 0;  // 返回购物车数量，默认值为0
        setShopCart({ count, isNew: true })
      }
    } else {
      messageToast.error(message);
    }
    // @ts-ignore
    if(globalThis.gtag) {
      // 触发 view_item 事件
      // @ts-ignore
      globalThis.gtag('event', 'add_to_cart', {
        user_id: userInfo?.id,
        items: JSON.stringify([{
          spu_code: productData.spuCode,
          sku_code: currentSku.itemCode,
          name: productData.name,
          category: productData.category,
          price: currentSku.salePrice,
          quantity: amount
        }]),
        spu_code: productData.spuCode,
        // sku_code: currentSku.itemCode,
        spu_id: productData.spuId,
        name: productData.name,
        category: productData.category,
        price: currentSku.salePrice,
        quantity: amount
      });

      // @ts-ignore
      globalThis.fbq('track', 'AddToCart', {
        content_ids: [currentSku.itemCode],
        sku_code: currentSku.itemCode,
        content_type: 'product',
        value: currentSku.salePrice, 
        currency: 'USD'
      });
    }
  }

  /**
   * 立即购买
   */
  const handleBuyNow = async () => {
    if (!userInfo?.email) {
      globalThis.document.getElementById("signInBtn")?.click();
      addGtag(Event_Name.login_click, {
        click_position: Login_Click.pdp_login_to_checkout,
      });
      return
    }

    if (!currentSku.itemCode) {
      return
    }
    const itemCode = currentSku.itemCode;
    const queryString = new URLSearchParams({ type: 'detail', itemCode: itemCode, amount: String(amount) }).toString()
    router.push(`/checkout?${queryString}`)
  }

  /**
   * 点击滚动到评价位置
   */
  const handleScrollToReview = () => {
    const reviewElement = document.querySelector('.reviews_self');
    if (!reviewElement) return;
    reviewElement.scrollIntoView({ behavior: 'smooth' });
  };

  /**
   * render add to cart Button 
   */
  const renderAddToCartButton = () => {
    return <>
        <BravveSmartButton 
          className="basis-320 py-12 h-48 grow shrink" 
          type='primary' 
          size="large" 
          disabled={isUnavailableOrStock} 
          onClick={addToCart}
        >
          Add to cart
        </BravveSmartButton>
        <BravveSmartButton 
            className={'basis-218 py-12 h-48 grow shrink ' + (isUnavailableOrStock ? ' opacity-30' : '')}
            size="large"
            disabled={isUnavailableOrStock} 
            style={{ cursor: isUnavailableOrStock ? 'not-allowed' : 'pointer' }} 
            onClick={handleBuyNow}
          >
            {userInfo?.email ?'Buy now':'Login to checkout'}
        </BravveSmartButton>
    </>
  }


  return (
    <>
      <h1 className='text-2xl font-medium leading-28 text-bravve-100'>
        {
          productData?.newProduct ?
              <span className="mr-7 inline-block h-22 w-40 items-center justify-center rounded-[1px] bg-bravve-100 text-center text-[13px] leading-[22px] text-white">
              New
              </span> :
          false
        }
        {productData.name}
        </h1>
      {
        (productData.rating ? parseFloat(productData.rating) : 0) === 0 ?
        null
        :
        <Flex gap={3} className='mt-12 h-22 leading-22'>
          <RateCustom value={productData.rating ? parseFloat(productData.rating) : 0} />
          <span className='text-base text-bravve-100 ml-6'>{productData.rating}</span>
          <span className='ml-12 text-bravve-sub-100 underline cursor-pointer' onClick={handleScrollToReview}>{productData.reviewCount} Reviews</span>
        </Flex>
      }

      <Flex gap={10} align="center" className='leading-32 mt-20'>
        <span className='text-3xl leading-30 font-medium '><Numeric value={currentSku?.salePrice} /></span>
        {
          currentSku?.discount && currentSku?.saleFlag ? 
          <>
            <span className='text-lg text-bravve-sub-100 line-through'><Numeric value={currentSku?.originPrice} /></span>
            <span className='h-20 leading-20 text-white text-center bg-error-100 text-xs px-10 inline-block'>-{currentSku?.discount}%</span>
          </>
          :
          null
        }
      </Flex>
      {/* tologoin */}
      {
        userInfo?.email ?
          null
          :
          <Flex align="center" justify='space-between'
            onClick={() => document.getElementById('signInBtn')?.click()}
            className='bg-bravve-bg-200 p-12 text-sm mt-8 mb-28 cursor-pointer'>
            <Flex align="start" wrap>
              <Flex align="center">
                <Image width={15} height={16} className='basis-[15px] h-16 grow-0 shrink-0' src="/img/productDetail/logo.png" alt="logo.image" />
                <span className='text-bravve-100 ml-6 mr-14 text-sm font-medium'>Bravve Discount</span>
              </Flex>
              {
                type === 'vertical' ?
                  <span className='text-sm mt-8 ml-20 bravve2:mt-0 bravve2:ml-0 text-bravve-sub-100'>Get <span className='text-error-100'>{process.env.NEXT_PUBLIC_discount}</span> off coupon when you register for your first account</span>
                  :
                  <span className='text-sm mt-8 ml-20 bravve1:mt-0 bravve1:ml-0 text-bravve-sub-100'>Get <span className='text-error-100'>{process.env.NEXT_PUBLIC_discount}</span> off coupon when you register for your first account</span>
              }
            </Flex>
            <iconpark-icon name="right" icon-id='right' color='#402C22' size="1.6rem"></iconpark-icon>
          </Flex>
      }

      {/* Free Shipping */}
      <Flex align="start" gap={10} className='text-success-100 font-medium mt-20'>
        {/* <iconpark-icon name="logistics" size="2.2rem" color='#24961B'></iconpark-icon> */}
        <Logistics size={22} />
        <div>
          <div className='text-[16px]'>Free Shipping on orders over <Numeric value={orderOverFreShippingAmount} /></div>
          <Flex align="center" className='mt-8 mb-6'>
            <span className='text-bravve-sub-100'>Estimated Get it within</span>
            <span className='text-bravve-100'>&nbsp;&nbsp;{ currentSku.sendOutRange > 3 ? `${(currentSku.sendOutRange / 4).toFixed(0)} month${(currentSku.sendOutRange / 4) > 1 ? 's' : ''}` : `${currentSku.sendOutRange} week${currentSku.sendOutRange > 1 ? 's': ''}` }</span>
          </Flex>
        </div>
      </Flex>

      <Collapse 
        className="skuSwitch" 
        expandIcon={(panelProps) => {
          return panelProps.isActive ? 
          <iconpark-icon size={'2rem'} name="minus" icon-id='minus' color='#796B64'></iconpark-icon>
          :
          <iconpark-icon size={'2rem'} name="plus" icon-id='plus' color='#796B64'></iconpark-icon>
        }}
        defaultActiveKey={['1', '2', '3', '4', '5', '6']} ghost items={[...items, ...items1]} 
      />

      <div className={'mt-32 md:mt-62 flex justify-between items-center '}>
        <div className={(isUnavailableOrStock ? ' opacity-30' : '')}>
          <BravveInputNumber
            width={'132px'}
            height={'45px'}
            value={Number(amount)}
            onChange={(type, value) => {
              // 利用后台 加减购物车数量
              if (type === 'plus') {
                setAmount(amount => amount + 1)
              } else {
                setAmount(amount => amount <= 1 ? 1 : amount - 1)
              }
            }}
          />
        </div>
        <div className='text-right'>
          <div className='text-xl font-medium text-bravve-100'>{total}</div>
          <div className='text-bravve-sub-100'>Total</div>
        </div>
      </div>
      
      {
        amount === 5 ?
        <div className='text-[#C31010] font-base mt-10' >
          The quantity you added has exceeded the limit. Each account is limited to 5 items.
        </div>
        : 
        null
      }

      <Flex align='center' gap={16} className={'mb-32 mt-26 md:mb-50'}>
        {renderAddToCartButton()}
      </Flex>

      <div>
        {/* 移动端底部购物车 */}
        <ViewportTracker>{renderAddToCartButton()}</ViewportTracker> 
      </div>

      <div className='border-[1.5px] border-bravve-line-100 px-16 py-20 rounded-xs text-bravve-100'>
        <Flex align='center' gap={10}>
          <iconpark-icon name="shield" size="2.2rem" icon-id='shield' color='#402C22' />
          <h2 className='text-lg'>Protecting Your Privacy</h2>
        </Flex>
        <div className='text-bravve-sub-100 mt-10 ml-32 mb-24'>Your privacy is of utmost importance to us. Rest assured, we are committed to
          safeguarding your information and will never disclose your personal data. To provide you with better service, we may use some of your
          information in accordance with our Privacy and Cookie Policy.</div>

        <Flex align='center' gap={10}>
          <iconpark-icon name="package" size="2.2rem" icon-id='package' color='#402C22' />
          <h2 className='text-lg'>30-Day Returns</h2>
        </Flex>
        <div className='text-bravve-sub-100 mt-10 ml-32 '>Not loving it? We offer returns for most items within 30 days of
          delivery for a refund. <Link className='text-bravve-100 underline' target='_blank' href={returnPricacyPolicyUrl(PrivacyPolicyPagesEnum.ReturnPolicy)}>30-Day Return Policy</Link></div>
      </div>
    </>
  )
}